import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import TagManager from 'react-gtm-module';
import { initAtatus } from '@/utils/atatus';
import { store, persistor } from './redux/store';
import './index.scss';
import App from './App';
import { loadLayout } from './navigation/lazy-load';
import { ROUTE_URLS } from './constant/routeURLs';
import reportWebVitals from './reportWebVitals';
import './legacyMainStyles';

initAtatus();

// Layout is lazy so the Salesforce embeds never load it. Every other entry fetches it now, in
// parallel with the page chunk, instead of only after Layout renders; the route retries on failure.
const EMBED_ENTRY_PATHS = [ ROUTE_URLS.EMBED_JETCARD, ROUTE_URLS.EMBED_OPPORTUNITY, ROUTE_URLS.EMBED_TRIP ];
if (!EMBED_ENTRY_PATHS.some((path) => window.location.pathname.startsWith(path))) {
  loadLayout().catch(() => {});
}

if (process.env.REACT_APP_GOOGLE_TAG_MANAGER_ENABLED && process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID) {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID,
  };
  TagManager.initialize(tagManagerArgs);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
